import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "raskStringFormat" })

export class StringFormatPipe implements PipeTransform {
    /**
     * Fungerar ungefär som String.Format i C#
     * Används enligt:
     * ```ts
     * myData.pirateSongLyric = "{1} gastar på en {2} mans {0}";
     * trans15 = 15;
     * transDeath = "död";
     * ```
     * `{{ myData.pirateSongLyric | raskStringFormat :"kista":trans15:transDeath }}` i en template producerar `15 gastar på en död mans kista`.
     */
    transform(value: string, ...args: (string | number)[]): string {
        for (let index = 0; index < args.length; index++) {
            value = value.replace(`{${index}}`, args[index].toString());
        }
        return value;
    }
}
